import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardKepalaSkbTimKinerjaProps
  extends React.HTMLAttributes<HTMLDivElement> {
  allowOtherRoles?: boolean
}

export const PageGuardKepalaSkbTimKinerja: FC<
  PageGuardKepalaSkbTimKinerjaProps
> = ({ children, allowOtherRoles = false }) => {
  const { isLoading: isLoadingRole, isTKKepalaSkb, leave } = useRoleContext()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  if (!isTKKepalaSkb && !allowOtherRoles) {
    leave()
    return null
  }

  return <>{children}</>
}
